import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [TranslateModule],
  selector: 'portal-vertise-small',
  templateUrl: './app-vertise-small.component.html',
  styleUrls: ['./app-vertise-small.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppVertiseSmallComponent implements OnInit {
  @Input() public screenWidthInPixel: number;
  public storeLink: SafeUrl;
  public visible = true;
  private deviceInfo: DeviceInfo;
  private deviceService: DeviceDetectorService = inject(DeviceDetectorService);

  public ngOnInit(): void {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isDesktopDevice = this.deviceService.isDesktop();
    const isApple = this.deviceInfo.os.toLowerCase() === 'ios';
    const isAndroid = this.deviceInfo.os.toLowerCase() === 'android';

    if (isDesktopDevice || !(isApple || isAndroid)) {
      this.storeLink = null;
    } else {
      this.storeLink = isAndroid ? 'https://play.google.com/store' : 'https://www.apple.com/itunes/';
    }
  }

  public closeMe(): void {
    this.visible = false;
  }
}
